<template>
  <v-flex>
    <v-layout style="margin-top: 15px;">
        <v-flex md7 class="text-right">
          <span class="text-center Label-user usuario-logado">
            <i class="mdi mdi-account"></i> {{ this.usuario.nome }} | {{ this.usuario.codCorretor }} | {{ this.usuario.tipo }} <span v-if="this.usuario.emailAuxiliar != null && this.usuario.emailAuxiliar != ''">({{ this.usuario.emailAuxiliar }})</span>
          </span>
        </v-flex>
        <v-flex md3 class="text-center">
          <v-btn
            :class="botaoClass"
            :disabled="!botaoEnabled"
            v-if="showBotao"
            @click="tab = 0; showDadosCorretor = true;"
          >
            {{ botaoTexto }}
          </v-btn>
        </v-flex>

        <!-- TODO: reativar quando o processamento de arquivos for liberado em produção
        <v-flex md1 class="text-right">
          <processamentosPanel />
        </v-flex>
        -->

        <v-flex md1 class="text-right">
          <v-container fluid fill-height justify-start class="text-right">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">                  
                  &nbsp;&nbsp;
                  <span class="icon28 icon-menu hover" v-on="on"></span>   
                </template>
                <v-list class="top-menu">
                  <v-list-item v-for="(item, index) in itensMenu" :key="index" @click="actionMenu(item.value)">
                    <v-list-item-title><i :class="'mdi ' + item.icon"></i> {{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
          </v-container>
        </v-flex>
    </v-layout>

    <v-dialog v-model="showDadosCorretor" width="1200" persistent :hide-overlay="true">
      <v-card>
        <v-overlay :value="fullLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-tabs
          v-model="tab"
          dark
          background-color="#5cd7fd !important"
          color="white"
          grow
          height="100px"
          v-show="showTabs"
        >
          <v-tabs-slider style="background-color:#007ca5 !important"></v-tabs-slider>

          <v-tab>
            <img src="../../../assets/icons/icons-corretora.svg" style="padding-right: 10px;"/>
            Dados da Corretora
          </v-tab>

          <v-tab :disabled="disableSocios">
            <img src="../../../assets/icons/icons-socios.svg" style="padding-right: 10px;"/>
            Dados dos Sócios
          </v-tab>
          
          <v-tab :disabled="disableDocumentos">
            <img src="../../../assets/icons/icons-documentos.svg" style="padding-right: 10px;"/>
            Envio de Documentos
          </v-tab>
          
          <v-tab :disabled="true">
            <span style="width: 65px; height: 28px; color: #ffffff; font-size: 24px; font-weight: 500;">
              3/3
            </span>
          </v-tab>
          
          <v-tab>
            <v-btn 
              :style="`background-color:transparent !important; width: 100% !important; height: 100px !important; border: none !important; box-shadow: none !important;`" 
              class="white--text" 
              @click="fechar()"
            >
              <span style="width: 65px; height: 28px; color: #ffffff; font-size: 24px; font-weight: 500;">
                X
              </span>
            </v-btn>

          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <DadosCorretorForm :ativarAba="ativarAba"  />
          </v-tab-item>

          <v-tab-item :disabled="disableSocios">
            <DadosSociosForm :ativarAba="ativarAba"/>
          </v-tab-item>

          <v-tab-item :disabled="disableDocumentos">
            <DocumentosForm :ativarAba="ativarAba" />
          </v-tab-item>

          <v-tab-item :disabled="disableSucesso">
            <SucessoForm :ativarAba="ativarAba" />
          </v-tab-item>

        </v-tabs-items>

      </v-card>
    </v-dialog>


    <v-dialog v-model="showTermoDegustacao" width="1000" persistent>
      <v-card>
        <v-overlay :value="fullLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card-text style="height:500px;" class="overflow-y-auto">
          Olá, Corretor! <br /><br />
          Como este é o seu primeiro acesso ao Portal, precisamos do seu aceite em nosso Termo de Confidencialidade, conforme abaixo:
          <br /><br />
          <strong>TERMO DE CONFIDENCIALIDADE</strong>
          <br /><br />
          <ol class="listaBemOrdenada">
            <li>
              Sem prejuízo da possibilidade de celebração de Contrato de Corretagem de Seguros para Intermediação na Contratação de Apólices, consideram-se <strong>INFORMAÇÕES CONFIDENCIAIS</strong> todas as informações e/ou materiais orais e escritos, revelados, transmitidos ou que sejam divulgados de uma Parte (“Parte Divulgadora”) à outra (“Destinatário”), ou a que as <strong>PARTES</strong> tenham acesso em decorrência do <strong>NEGÓCIO</strong> e que não sejam de conhecimento público, incluindo, mas não se limitando, àquelas que façam referência ao histórico, operações, dados contábeis, marketing, fórmulas, procedimentos internos, especificações técnicas, patentes, dados, programas de computador, desenhos, aspectos legais e a situação econômica, financeira e fiscal das <strong>PARTES</strong>, incluindo documentos, arquivos, relatórios financeiros, relatórios jurídicos, informações contábeis e fiscais, contratos, informes, memorandos, correspondências físicas e digitais, mensagens eletrônicas, bem como àquelas relacionadas à hábitos e práticas de consumo individual ou coletivo, relativas a pesquisas de opinião,  mercados  ou quaisquer outros estudos de tal natureza ou qualquer outro tipo de informação relacionada a boa análise do <strong>NEGÓCIO</strong>, devendo as <strong>PARTES</strong> manter o mais absoluto sigilo sobre elas, não devendo divulgá-las a terceiros ou utilizá-las para finalidade diversa daquela pactuada neste Termo, sob pena de a parte infratora responder por perdas e danos, observadas as seguintes exceções:
              <ol class="listaBemOrdenada">
                <li>
                  Se a informação for de domínio público no momento da revelação ou vier a se tornar de domínio público após a revelação, sem que as <strong>PARTES</strong> tenham contribuído para a divulgação da informação ao público.
                </li>
                <li>
                  Seja a informação for revelada por força de ordem válida de autoridade pública ou por determinação judicial, somente até a extensão de tais ordens, desde que a parte requisitada tenha notificado a parte contrária de tal ordem, por escrito.
                </li>                
              </ol>
            </li>
            <li>
              Dada a natureza do <strong>NEGÓCIO</strong>, do objeto do presente <strong>TERMO</strong> e porque assim se convenciona, as <strong>PARTES</strong> obrigam-se, por si, seus profissionais, sócios e prepostos, a:
              <ol class="listaBemOrdenada">
                <li>
                  manter absoluto sigilo sobre as operações, dados, materiais, pormenores, informações, documentos, especificações técnicas ou comerciais, inovações e aperfeiçoamento tecnológicos ou comerciais, softwares de propriedade da outra Parte ou de seus clientes, inclusive quaisquer programas, rotinas ou arquivos a que eventualmente tenha ciência ou acesso, ou que lhe venha a ser confiado, em razão deste Termo;
                </li>
                <li>
                  As <strong>PARTES</strong> devem tomar às suas expensas, as precauções e providências necessárias para assegurar o sigilo das <strong>INFORMAÇÕES CONFIDENCIAIS</strong> e para restringir ao máximo o uso não autorizado das mesmas, inclusive requerendo medidas judiciais e administrativas, se for o caso;
                </li>
                <li>
                  responder perante a Parte Prejudicada e terceiros prejudicados, civil e criminalmente, por si, seus profissionais, contratados e/ou prepostos, pela eventual quebra de sigilo das informações que tenha acesso ou ciência, direta ou indiretamente, em virtude deste Termo; e
                </li>
                <li>
                  convencionam as <strong>PARTES</strong> que, em caso de violação às obrigações aqui estabelecidas, que implique em prejuízos de ordem moral ou material deverá a parte prejudicada promover a competente indenização por perdas e danos sofridos, os quais incluem, mas não se limitam a, custas, despesas e honorários advocatícios incorridos pela parte inocente para defesa de seus direitos, sem prejuízo das medidas de natureza penal cabíveis.
                </li>
              </ol>
            </li>
          </ol>        
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :class="botaoClass" @click="showTermoDegustacao = false; showBannerDegustacao = true;">
            LI E CONCORDO COM OS TERMOS
          </v-btn>          
        </v-card-actions>
      </v-card>
    </v-dialog>    

    <v-dialog v-model="showBannerDegustacao" width="520"  style="height:400px;">
      <v-card>
        <v-card-text>
              <v-card class="text-center text-white cardPointer" @click="TermoBanner();" color="#25d366" style="width:500px; height: 375px; background: url('/upload/degustacao/Pop-Up-Boas-Vindas-Portal-do-Corretor_500x375.png') center center; background-repeat: no-repeat; background-size: cover;" outlined>
              </v-card>           
        </v-card-text>

      </v-card>
    </v-dialog>        

  </v-flex>
</template>

<script>
import DadosCorretorForm from "@/components/portal/corretorDegustacao/DadosCorretor.vue";
import DadosSociosForm from "@/components/portal/corretorDegustacao/DadosSocios.vue";
import DocumentosForm from "@/components/portal/corretorDegustacao/Documentos.vue";
import SucessoForm from "@/components/portal/corretorDegustacao/Sucesso.vue";
// import processamentosPanel from "@/components/portal/layout/ProcessamentosPanel.vue";
import Helpers from "@/utilities/Helpers";
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [Helpers],
  components: {
    DadosCorretorForm,
    DadosSociosForm,
    DocumentosForm,
    SucessoForm,
    // processamentosPanel
  },

  created() {
    this.carregarCorretorDegustacao();
  },

  data() {
    return {
      itensMenu: [
        { title: 'Mosaico', value: "voltar", icon: "mdi-blur" },
        { title: 'Configurações', value: "config", icon: "mdi-settings" },
        { title: 'Sair', value: "sair", icon: "mdi-logout" },
        //{ title: 'Perfil', value: "perfil", icon: "mdi-account" },
      ],
      corretor: null,
      showDadosCorretor: false,
      showTabs:true,
      disableSocios: true,
      disableDocumentos: true,
      disableSucesso: true,
      tab: null,
      botaoTexto: "COMPLETAR CADASTRO",
      botaoClass: "info",
      botaoEnabled: true,
      showBotao:false,
      showTermoDegustacao: false,
      showBannerDegustacao: false,
      fullLoading: false,
      flgCorretorDeustacao: false
    }
  },

  watch: {
    "usuario.codCorretor"() {
      this.carregarCorretorDegustacao();
    },
  },

  methods: {

      TermoBanner()
      {
        this.showBannerDegustacao = false; 
        this.tab = 0; 
        this.showDadosCorretor = true;
        localStorage.setItem("termoBannerDegustacao", false);
      },

      carregarCorretorDegustacao()
      {
        //let corretorJwt = this.parseJwtToUserFromStorage();
        let corretorJwt = 
        {
          codCorretor : this.usuario.codCorretor,
          degustacao : '0'
        };
        //console.log("corretorJwt:- ", corretorJwt);
        
        if(corretorJwt.codCorretor.length >= 5) { 
          corretorJwt.degustacao = '1'; 
        }
    
        if(corretorJwt.degustacao != "1") {
          this.showTermoDegustacao = false;
          this.showBotao = false;
          return;
        }
        else
        {
          this.flgCorretorDeustacao = true;
          this.showBotao = true;
        }

        this.fullLoading = true;     
        this.loading = true;

        let codigoCorretor = this.usuario.codCorretor;
        let url = "CorretorDegustacao/Selecionar?id="+codigoCorretor;

        Vue.prototype.$httpPortal.get(url)
        .then(res => {

            let dataRequest = res.data;
            //console.log("CorretorDegustacao/Selecionar");
            //console.log(res.data);

            if(!dataRequest.Sucesso){
              // this.showToast("error", "Erro", "Erro ao carregar os dados para inicializar o corretor degustação.");
              this.loading = false;
              this.fullLoading = false;
            }

            let corretorDegustacao = dataRequest.ObjetoRetorno;
            this.loading = false;
            this.fullLoading = false;
            this.corretor = corretorDegustacao;
            this.tratarBotaoCadastro();

            return corretorDegustacao;
            
        })
        .catch(ex => {
            console.log(ex);
            // this.showToast("error", "Erro", "Ocorreu um problema ao inicializar os dados do corretor debustação.");
            this.loading = false;
            this.fullLoading = false;
        });           
      },

    tratarBotaoCadastro() {

      if (this.corretor && this.corretor.Etapa !== null && this.corretor.Etapa !== undefined) {

        // 1:PreCadastro|| 2:DadosCadastras ||  3:DadosFinanceiros ||4:EnvioDeDocumentacao
        if(this.corretor.Etapa == 0 || this.corretor.Etapa == 1 || this.corretor.Etapa == 2 || this.corretor.Etapa == 3 || this.corretor.Etapa == 4){
          this.botaoTexto = "COMPLETAR CADASTRO";
          this.botaoClass = "info";
          this.botaoEnabled = true;
          this.showTermoDegustacao = true;
          return;
        }

        //5:AnaliseGERIMP
        if(this.corretor.Etapa == 5){
          this.botaoTexto = "CADASTRO EM ANALISE";
          this.botaoClass = "success";
          this.botaoEnabled = false;
          this.showTermoDegustacao = false;
          return;
        }

        //6:PendenciaCadastral
        if(this.corretor.Etapa == 6){
          this.botaoTexto = "PENDÊNCIA CADASTRAL";
          this.botaoClass = "warning";
          this.botaoEnabled = true;
          this.showTermoDegustacao = false;
          return;
        }
        
        //9:CadastroReprovado
        if(this.corretor.Etapa == 9){
          this.botaoTexto = "CADASTRO REPROVADO";
          this.botaoClass = "warning";
          this.botaoEnabled = false;
          this.showTermoDegustacao = false;
          return;
        }

        //10:CadastroAprovado
        if(this.corretor.Etapa == 10){
          this.botaoTexto = "CADASTRO APROVADO";
          this.botaoClass = "warning";
          this.botaoEnabled = false;
          this.showBotao = false;
          this.showTermoDegustacao = false;
          return;
        }
      }
    },

    salvarDados(corretorModel, urlAction, step){
      this.fullLoading = true;
        let urlPost = "CorretorDegustacao/" + urlAction

        //Copia sem referencia do objeto
        let corretorModelToPost = Object.assign({}, corretorModel);

      if(corretorModelToPost.AliquotaEnquadramentoISSQN != undefined){
              corretorModelToPost.AliquotaEnquadramentoISSQN = corretorModelToPost.AliquotaEnquadramentoISSQN.toString().replace(",",".");
      }
      
      //Mudo o formato da data para salvar no DB
        corretorModelToPost.DataNascimento = this.formatarDataParaDB(corretorModelToPost.DataNascimento)

        for (let index = 0; index < corretorModelToPost.Socios.length; index++) {
          corretorModelToPost.Socios[index].DataNascimento = this.formatarDataParaDB(corretorModelToPost.Socios[index].DataNascimento);
        }

        Vue.prototype.$httpPortal.post(urlPost, corretorModelToPost).then(() => {
            this.loading = false;
            this.fullLoading = false;

            this.corretor = corretorModel;   
            if (step === 1) {
              this.disableSocios = false;
              this.tab = step 
              return;             
            }

            if (step === 2) {
              this.disableDocumentos = false;
              this.tab = step 
              return;             
            }
        })
        .catch(ex => {
            console.log(ex);
            this.showToast("error", "Erro", "Ocorreu um problema ao salvar os dados do corretor.");
            this.loading = false;
            this.fullLoading = false;
        });   
    },    

    actionMenu(value) {
      if(value == "voltar")
      {
        window.location.href = process.env.VUE_APP_API_ACESSO_RAIZ+"/Account/Panel";
      }

      if(value == "sair") {
        localStorage.clear();
        window.location.href = "/logout";
      }

      if(value == "config"){
        window.location.href = "/configuracoes";
      }
      if(value == "notificacoes")
      {
        window.location.href = "/notificacoes";
      }
    },

    ativarAba: function(step, corretorModel) {

      localStorage.setItem("corretorDegustacao", JSON.stringify(corretorModel));

      if (step === 0) {
        this.tab = 0
      }

      if (step === 1) {
        //debugger;
        console.log(corretorModel);

        if(corretorModel != undefined){
            if(!this.validarDadosCorretora(corretorModel)){
              return;
            }

            this.salvarDados(corretorModel,"AlterarDadosCadastrais",step);
        }else{
        this.disableSocios = false;
        this.tab = 1
        }


      }

      if (step === 2) {
        //debugger;
        console.log(corretorModel);

        if(corretorModel != undefined){
          if(!this.validarDadosSocio(corretorModel)){
            return;
          }

          this.salvarDados(corretorModel,"AlterarSocio",step);
        }else{
          this.disableDocumentos = false;
          this.tab = 2
        }
      }

      if (step === 3) {
        this.disableSucesso = false;
        this.showTabs = false;
        this.botaoEnabled = false;
        this.botaoTexto = "CADASTRO EM ANALISE";
        this.botaoClass = "success";
        this.tab = 3
      }

      if (step === 4) {
        this.fechar();
      }
    },

    validarDadosCorretora(corretorModel){
        // CNPJ e Registro SUSEP
        if(!this.validarTextoObrigatorio(corretorModel.RazaoSocial,4, "Razão Social")){
            return false;
        }

        if(!this.validarTextoObrigatorio(corretorModel.Susep, 5,"Susep")){
            return false;
        }

        if(!this.validarInteiroObrigatorio(corretorModel.CNAE,"CNAE")){
            return false;
        }

        if(!this.validarInteiroObrigatorio(corretorModel.NumeroFuncionario,"Número de funcionários")){
            return false;
        }

        // Endereço
        if(!this.validarTextoObrigatorio(corretorModel.EnderecoRua,5, "Endereço")){
            return false;
        }

        if(!this.validarTextoObrigatorio(corretorModel.EnderecoNumero,1, "Endereço Número")){
            return false;
        }

        if(!this.validarTextoObrigatorio(corretorModel.EnderecoBairro,3, "Endereço Bairro")){
            return false;
        }

        if(!this.validarTextoObrigatorio(corretorModel.EnderecoCep,7, "Endereço Cep")){
            return false;
        }

        if(!this.validarTextoObrigatorio(corretorModel.EnderecoCidade,3, "Endereço Cidade")){
            return false;
        }

        if(corretorModel.Produtos.length == 0){
          this.showToast("error", "Erro", "Selecione pelo menos 1 produto.");
          return false;
        }

        if(corretorModel.Produtos.length > 8){
          this.showToast("error", "Erro", "Selecione no máximo 8 produto.");
          return false;
        }

        // if(!this.validarTextoObrigatorio(corretorModel.EnderecoEstado,3, "Endereço Estado")){
        //     return false;
        // }   

        if(corretorModel.UtilizaMulticalculo){
          if(!this.validarInteiroObrigatorio(corretorModel.MulticalculoTipo,"Tipo Multi cálculo")){
            return false;
          }
        }

          if(!this.validarInteiroObrigatorio(corretorModel.ContatoPreferencia,"Preferencia contato")){
            return false;
          }

          if(!this.validarUrl(corretorModel.Facebook,"Facebook")){
            return false;
          }

          if(!this.validarUrl(corretorModel.Instagram,"Instagram")){
              return false;
          }

          if(!this.validarUrl(corretorModel.Linkedin,"Linkedin")){
              return false;
          }

          if(!this.validarUrl(corretorModel.Twitter,"Twitter")){
              return false;
          }

          if(!this.validarUrl(corretorModel.SiteCorretora,"SiteCorretora")){
              return false;
          }
        
        /// Multicálculo e Redes Sociais
            

      return true;
    },

    validarUrl(url, nome){

      if(url == "" || url== undefined){
        return true;
      }
      
      if(!this.isUrl(url)){
          this.showToast("error", "Erro", "O link do '"+nome+"' é inválido.");
          return false;
      }
      return true;
    },

    validarDadosSocio(corretorModel){
    // CNPJ e Registro SUSEP
      if(!this.validarTextoObrigatorio(corretorModel.Nome,2, "Nome")){
          return false;
      }

      if(!this.validarTextoObrigatorio(corretorModel.Cpf,5, "CPF")){
        return false;
      }

      return true;
    },

    fechar() {
      this.showDadosCorretor = false;
    },

    validarTextoObrigatorio(valor, tamanho, campoNome){
        if( valor == undefined || valor == "" || valor.length <= tamanho){
          this.showToast("error", "Erro", "O campo '"+campoNome+"' deve ter pelo menos " + tamanho + " caracteres.");
          return false;
        }
        return true;
    },

    validarInteiroObrigatorio(valor, campoNome){
        if(valor == "0" || valor == ""){
            this.showToast("error", "Erro", "O campo '"+campoNome+"' é obrigatório.");
            return false;          
        }
        return true;
    }
  },

  computed: {
  ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
  },

  mounted()
  { 
    let _mostrarTermoBanner = localStorage.getItem("termoBannerDegustacao");
    if(_mostrarTermoBanner != 'false' && this.flgCorretorDeustacao == true)
    {
      this.showTermoDegustacao = true;
    }
  } 
}
</script>

<style lang="scss">
  .top-menu{
    width: 180px;
    background-color: #ffffff !important;
    opacity: 1;
    border:1px solid #dddddd !important;
    padding: 5px 20px !important;

    .v-list-item .v-list-item__title{
      font-size: 14px;
      margin: 0 10px;
    }
  }
  .Label-user{
    color: var(--grey-medium) !important;
  } 
  .icon-menu{
    background-color: var(--grey-medium) !important;
  } 
  .usuario-logado{
    font-size: 14px;
    font-weight: bold;
  }

.listaBemOrdenada {
  counter-reset: item;
  padding: 5px;
}
.listaBemOrdenada li {
  display: block;
  padding: 5px;
}
.listaBemOrdenada li:before {
  content: counters(item, ".") " ";
  counter-increment: item;
  font-weight: bold;
}

.cardPointer {
  cursor: pointer;
}
</style>